/**
 * API utility with automatic token refresh for Admin Portal
 */

import { authenticatedFetch } from '../lib/api';

export const apiFetch = authenticatedFetch;
export default apiFetch;


